import axiosInstance from 'api/axiosInstance'

export const getNotificationSettings = async () => {
    const { data } = await axiosInstance({
        method: 'GET',
        url: '/api/user/profile-notification-settings'
    })
    return data?.data
}
export const getProfileNotificationSettings = async (id: string) => {
    const { data } = await axiosInstance({
        method: 'GET',
        url: `/api/user/profile-notification-settings?other_user_id=${id}`
    })
    return data?.data
}

export const updateNotificationSettings = async (val: any) => {
    const { data } = await axiosInstance({
        method: 'PUT',
        url: '/api/user/notification-setting-types',
        data: val
    })
    return data
}

export const putNotifications = async (setup: Record<string, boolean>) => {
    const { data } = await axiosInstance({
        method: 'PUT',
        url: '/api/user/notification-settings',
        data: setup
    })
    return data
}
